import '../../scss/common/components/header.scss'

import { useMsal } from '@azure/msal-react'
import {
  Button,
  Container,
  Drawer,
  Flex,
  Grid,
  GridItem,
} from '@sainsburys-tech/fable'
import { Close, Menu as FableMenu } from '@sainsburys-tech/icons'
import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'

import { getFirstName } from '../../utils/colleagueDetails'
import { getLocalStorePlanners } from '../../utils/localPlanner'
import { getUserStore } from '../../utils/localStore'
import { Context } from '../Context/context'
import { HeaderNavItem } from '../enums/HeaderItems'
import { Menu } from '../enums/MenuEnum'
import { IStore } from '../types/IStore'
import { IStorePlanners } from '../types/IStorePanners'
import { IUser } from '../types/IUser'

interface HeaderMenuProps {
  title: string
  navItems?: HeaderNavItem[]
  activeMenuType?: Menu
}

const FableHeader = (props: HeaderMenuProps) => {
  const { state } = useContext(Context)
  const [store] = useState<IStore>(getUserStore())
  const [isMenuBarOpen, setIsMenuBarOpen] = useState<boolean>()
  const [storePlanners] = useState<IStorePlanners>(getLocalStorePlanners())
  const { instance } = useMsal()

  const renderUsername = () => {
    const user = state.user as IUser
    const firstname = getFirstName(user.fullname)
    return <span data-testid='username'>{`Hello ${firstname}`}</span>
  }

  const renderPlannerSelection = (testId: string = 'planner') => (
    <span data-testid={testId}>
      <Link
        to={{
          pathname: '/plannerselection',
          search: '?reset=true',
        }}
      >
        Switch planner
      </Link>
    </span>
  )

  const toggleMenuBar = () => {
    setIsMenuBarOpen(!isMenuBarOpen)
  }

  const renderStoreSelection = () => (
    <span data-testid='store'>
      <Link
        to={{
          pathname: '/storesetting',
          search: '?reset=true',
        }}
      >
        Store:{''}
        <span className='c-common-header-store-number'>{`${store.storeCode}`}</span>
      </Link>
    </span>
  )

  const renderLogout = () => (
    <span data-testid='logout'>
      <a href='#' onClick={() => void instance.logoutRedirect()}>
        Logout
      </a>
    </span>
  )

  const secondaryNavigation = () => (
    <nav className={'secondary_main_navigation'}>
      <ul className={'ds-c-header__navigation-list inline-list'}>
        {props.navItems &&
          props.navItems.map((item) => (
            <li
              key={item.id}
              data-testid={item.id}
              className={props.activeMenuType === item.type ? 'active' : ''}
              aria-current={
                props.activeMenuType === item.type ? 'page' : undefined
              }
              style={{ marginRight: '1rem' }}
            >
              <Link
                className={'ds-c-header__navigation-list-item--element'}
                to={item.to}
              >
                {item.text}
              </Link>
            </li>
          ))}
      </ul>
    </nav>
  )

  const primaryNavigation = (testId: string = 'planner-header') => (
    <nav className={'primary_main_navigation'}>
      <ul
        className={
          'ds-c-header__navigation-list c-common-header-navigation-list inline-list'
        }
      >
        <li>{renderUsername()}</li>
        <li>
          {storePlanners.count > 1 && <>{renderPlannerSelection(testId)}</>}
        </li>
        <li>{renderStoreSelection()}</li>
        <li>{renderLogout()}</li>
      </ul>
    </nav>
  )

  return (
    <>
      <header style={{ backgroundColor: 'white' }}>
        <Container size={'lg'} padding={'none'} className={'main-header'}>
          <Grid cols={12}>
            <GridItem colSpan={{ default: 12, md: 12 }}>
              <section aria-label={'Main Header Navigation'}>
                <Flex
                  direction={'row'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                >
                  <Flex direction={'row'} alignItems={'center'}>
                    <Button
                      className={'hamburger_menu'}
                      icon={<FableMenu />}
                      onClick={() => toggleMenuBar()}
                    />
                    <span className='ds-c-header__main-bar-app'>
                      {props.title}
                    </span>
                  </Flex>
                  {primaryNavigation()}
                </Flex>
              </section>
            </GridItem>
          </Grid>
        </Container>
        <hr />

        <Container size={'lg'} padding={'md'} className={'sub-header'}>
          <Grid cols={12}>
            <GridItem colSpan={{ default: 12, md: 12 }}>
              <section aria-label={'Sub Header Navigation'}>
                <Flex
                  direction={'row'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                >
                  {secondaryNavigation()}
                </Flex>
              </section>
            </GridItem>
          </Grid>
        </Container>
      </header>

      <Drawer
        className={'main_menu_drawer'}
        isOpen={isMenuBarOpen}
        onClick={toggleMenuBar}
        renderFooter={
          <Flex direction={'column'} className={'main_menu_panel top_border'}>
            {primaryNavigation('planner-drawer')}
          </Flex>
        }
      >
        <Flex direction={'column'} className={'main_menu_panel'}>
          <section>
            <Flex
              direction={'row'}
              alignItems={'center'}
              style={{ marginBottom: '20px' }}
            >
              <Button
                size={'md'}
                onClick={() => toggleMenuBar()}
                icon={<Close />}
              />
              <span className='ds-c-header__main-bar-app'>{props.title}</span>
            </Flex>
            {secondaryNavigation()}
          </section>
        </Flex>
      </Drawer>
    </>
  )
}

export default FableHeader
